import {
  Box,
  createTheme,
  Grid,
  ThemeProvider,
  Typography,
  useTheme,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";

import { UserContext } from "../../utils/UserContext";
import ImgDoubleCols from "../ImgDoubleCols/ImgDoubleCols";
import TimeOfImage from "../TimeOfImage/TimeOfImage";

function DownloadableImage({ handleImageDownloadable, displayOnly }) {
  const { user, shareableImgRef, connectionScore } = useContext(UserContext);
  const userFirstName = user.firstName;

  const theme = useTheme();

  const [connectionLevel, setConnectionLevel] = useState("");

  useEffect(() => {
    handleImageDownloadable();
  }, []);

  const shareableImageTheme = createTheme({
    typography: {
      fontFamily: ['"Space Mono"', "monospace"].join(","),
    },
    components: {
      MuiListItemIcon: {
        styleOverrides: {
          root: {
            minWidth: "20px",
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
      },
      MuiListItemText: {
        styleOverrides: {
          root: {
            margin: 0,
          },
        },
      },
    },
    palette: {
      goldPrimary: "#F4C01E",
      whitePrimary: theme.palette.whitePrimary.main,
      blackPrimary: theme.palette.blackPrimary.main,
    },
  });

  const handleConnectionLevel = () => {
    let level = null;
    switch (true) {
      case connectionScore >= 9.0 && connectionScore <= 10:
        setConnectionLevel("classic");
        level = "classic";
        break;
      case connectionScore >= 8.0 && connectionScore <= 8.9:
        setConnectionLevel("ultra");
        level = "ultra";
        break;
      case connectionScore >= 7.0 && connectionScore <= 7.9:
        setConnectionLevel("high");
        level = "high";
        break;
      case connectionScore >= 6.0 && connectionScore <= 6.9:
        setConnectionLevel("medium");
        level = "medium";
        break;
      case connectionScore >= 5.0 && connectionScore <= 5.9:
        setConnectionLevel("low");
        level = "low";
        break;
      case connectionScore < 4.9:
        setConnectionLevel("notforme");
        level = "notforme";
        break;
      default:
        // eslint-disable-next-line no-console
        console.error("Invalid Value!");
    }
    return level; // Return the computed connection level
  };

  const returnStampColor = () => {
    switch (connectionLevel) {
      case "classic":
        return "#000";
      case "ultra":
        return "#4d089a";
      case "high":
        return "#090c9b";
      case "medium":
        return "#218246";
      case "low":
        return "#FF7B29";
      case "notforme":
        return "#FF1616";
      default:
        return null;
    }
  };

  useEffect(() => {
    handleConnectionLevel();
  });

  return (
    <Box sx={{ opacity: 1 }}>
      <ThemeProvider theme={shareableImageTheme}>
        <Box
          component="article"
          ref={shareableImgRef}
          sx={{
            bgcolor: theme.palette.blackSecondary.main,
            width: "900px",
            height: "900px",
            padding: "0 4rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid
            container
            spacing={12}
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={4}>
              <Typography
                component="p"
                variant="h3"
                sx={{
                  fontWeight: 600,
                  textTransform: "uppercase",
                  textAlign: "center",
                }}
              >
                {`${userFirstName}'s COMP Score`}
              </Typography>
            </Grid>
            <ImgDoubleCols
              connectionLevel={connectionLevel}
              returnStampColor={returnStampColor}
              displayOnly={displayOnly}
            />
            <TimeOfImage displayOnly={displayOnly} />
          </Grid>
        </Box>
      </ThemeProvider>
    </Box>
  );
}

DownloadableImage.propTypes = {
  handleImageDownloadable: PropTypes.func.isRequired,
  displayOnly: PropTypes.bool.isRequired,
};

export default DownloadableImage;
